export default __webpack_public_path__ + "static/media/yeezy5.0b5ed327.jpg";